import { InferOutput, maxLength, pipe, string } from 'valibot'

export const PassphraseSchema = pipe(string(), maxLength(40))

export type Passphrase = InferOutput<typeof PassphraseSchema>
